'use strict'

/**
 * Constants file with the endpoints used by users module to call a REST-services of the backend API.
 *
 * @type {number}
 *
 * @author Valentin Agudelo Aquite
 * @since 20/02/2020 01:01 PM
 * @version 1.0.0
 */

/* Backend endpoints */
const ROOT_URI = `${process.env.VUE_APP_API_URL}`
const ROOT_WEB_URI = `${process.env.VUE_APP_WEB_URL}`

export const PAGAR_REFERENCIA = `${ROOT_URI}publicos/pagos/`

export const FIELDS_DEFAULT_EPAYCO_CHECKOUT = {
  SIN_IVA: '0',
  EXTERNAL_CHECKOUT: 'false'
}

export const SERVICIO_PASARELA_PAGO_CODIGO = 2

export const URL_RESPONSE_EPAYCO = `${ROOT_WEB_URI}confirmacion-de-pagos`
export const WEBHOOK_CONFIRMACION_EPAYCO = `${ROOT_URI}epayco-webhooks/confirmacion-transaccion`
